import React from 'react';
import { withIsMobile } from 'treeline-react-core-components/WindowSizeProvider';
import { connectToTitle } from './containers/TitleDataStore';
import TitleActionsScroller from './TitleActionsScroller';
import './titleBiblio.less';
import TitleJacketImage from './UI/TitleJacketImage';
import { getTitleJacketUri } from './util';

export class TitleDetailJacketFrame extends React.Component {
	componentDidMount() {
		const { title } = this.props.titleDataStore.state;
		const titleJacketImageUri = getTitleJacketUri(title);
		return (
			(!title.sku || !titleJacketImageUri) &&
			this.props.setDoShowTitleJacket &&
			this.props.setDoShowTitleJacket(false)
		);
	}

	render() {
		const isMobile = this.props.isMobile();
		const {
			isProductDataLoading,
			title,
			isCollaborativeListDataLoading,
			collaborativeLists,
		} = this.props.titleDataStore.state;
		if (!isProductDataLoading) {
			if (!isCollaborativeListDataLoading) {
				const {
					downloadableSkus,
					requestableSkus,
					digitalCopyInfo,
				} = collaborativeLists;
				title.isDownloadable =
					downloadableSkus && downloadableSkus.includes(title.sku);
				title.isRequestable =
					requestableSkus && requestableSkus.includes(title.sku);

				const availableReviewCopyFormats = digitalCopyInfo.filter(
					dci => dci.sku === title.sku,
				);

				if (
					availableReviewCopyFormats &&
					availableReviewCopyFormats.length &&
					availableReviewCopyFormats[0]
				) {
					var availableReviewCopyFormat =
						availableReviewCopyFormats[0];
					title.digitalCreatedDate =
						availableReviewCopyFormat.createdDate;
					title.digitalUpdatedDate =
						availableReviewCopyFormat.updatedDate;
				}
			}
		}
		const size = isMobile ? 'fillwidth-image' : 'medium-image';
		return (
			<div className="title-biblio">
				<div
					className="flex biblio-section"
					style={{ marginBottom: '10px' }}>
					<div
						className={size}
						style={{
							margin: isMobile ? '20px' : '0 0 0 10px',
							position: 'relative',
						}}>
						<TitleJacketImage
							product={title}
							doNotPadRight={true}
						/>
						<div className="title-actions-scroller">
							<TitleActionsScroller
								title={title}
								tooltipPlacement="leftTop"
								doAllowOpenReviewCopyActionOnMount
							/>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default connectToTitle(withIsMobile(TitleDetailJacketFrame));
